// PostHog и Amplitude грузятся отдельными чанками после старта, а не лежат
// в main.js. Вместе это ~350 КБ несжатого кода, и для того, чтобы показать
// форму входа, не нужен ни один байт из них.
//
// Все вызовы идут через withPosthog / withAmplitude: колбэк выполнится,
// когда библиотека загрузится и будет проинициализирована, порядок вызовов
// сохраняется (цепочка на одном промисе). Если аналитика выключена -
// колбэк просто не вызывается, и библиотека не скачивается вовсе.

const isProduction = process.env.NODE_ENV === 'production'
const isPosthogEnabled = process.env.REACT_APP_ENABLE_POSTHOG === 'true'

let amplitudePromise = null
let posthogPromise = null

const loadAmplitude = () => {
  if (!isProduction) return null
  if (!amplitudePromise) {
    amplitudePromise = import('@amplitude/analytics-browser').then((amplitude) => {
      amplitude.init('ea795b1a8f90c5a6411b752ede35e010', {
        defaultTracking: { pageViews: true, sessions: true },
      })
      return amplitude
    })
  }
  return amplitudePromise
}

const loadPosthog = () => {
  if (!isPosthogEnabled) return null
  if (!posthogPromise) {
    posthogPromise = import('posthog-js').then(({ default: posthog }) => {
      posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
        api_host: process.env.REACT_APP_POSTHOG_HOST,
        defaults: '2025-05-24',
        capture_exceptions: true,
        debug: false,
      })
      return posthog
    })
  }
  return posthogPromise
}

const run = (promise, callback) => {
  if (!promise) return
  promise.then(callback).catch((err) => {
    // Блокировщик рекламы или обрыв сети не должны ронять приложение
    console.warn('Analytics is unavailable', err)
  })
}

// Стартуем только после window.load и когда браузер освободится: иначе на
// медленном канале чанки аналитики качаются параллельно со стилями, шрифтами
// и переводами и отбирают у них полосу - экран входа появляется позже.
export const initAnalytics = () => {
  const start = () => {
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1))
    idle(() => {
      loadAmplitude()
      loadPosthog()
    }, { timeout: 5000 })
  }

  if (document.readyState === 'complete') start()
  else window.addEventListener('load', start, { once: true })
}

export const withAmplitude = (callback) => run(loadAmplitude(), callback)

export const withPosthog = (callback) => run(loadPosthog(), callback)
